(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('HideDeletedFilter', [HideDeletedFilterFn]);

    // removes the deleted entities
    function HideDeletedFilterFn() {
        return function (items, showAll) {
            if (items) {
                if (typeof showAll !== 'undefined') {
                    return items.filter(function (item) {
                        return showAll || !showAll && item.deleted === false;
                    });
                } // if
                else {
                    return items.filter(function (item) {
                        return !item.deleted || item.deleted === false;
                    });
                } // else
            }// if
        };
    }
})();
